<template lang="pug">
    .row
        div.col-xs-12.col-sm-4(
            v-for="type in types"
            :key="type.id"
        )
            .box.p-a
                transition(
                    name="fade"
                    mode="out-in"
                )
                    .content(key="content")
                        .pull-left.m-r
                            span(:class="type.class")
                                i.material-icons(v-html="type.icon")
                        .clear
                            span
                                h4.m-a-0.text-lg._300
                                    span(v-if="!loading") RM {{ type.total }}
                                    small.text-xs(v-show="loading")
                                        i.fa.fa-spinner.fa-spin.fa-2x
                                small.text-muted {{ type.name }}
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    data() {
        return {
            loading: true,
            types: [
                {
                    id: 'voided_receipts',
                    name: 'Total Voided Receipts',
                    total: null,
                    class: 'w-48 rounded primary',
                    icon: '&#xE25C;',
                },
                {
                    id: 'returned_items',
                    name: 'Total Returned Items',
                    total: null,
                    class: 'w-48 rounded accent',
                    icon: '&#xe15c;',
                },
                {
                    id: 'aborted_fuel',
                    name: 'Total Aborted Fuel',
                    total: null,
                    class: 'w-48 rounded warn',
                    icon: '&#xe561;',
                },
            ],
        };
    },

    computed: {
        ...mapGetters(['dateFilter']),
        ...mapState('tillFilter', ['filters']),

        api() {
            return Laroute.route('franchise.report.voidedsales.es.summary', {
                id: this.activeOutlet,
            });
        },

        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
    },

    watch: {
        activeOutlet() {
            this.getSumTransaction();
        },

        dateFilter(a, b) {
            if (a == b) return;
            this.getSumTransaction();
        },

        filters: function(to, from) {
            if (to === from) return;
            this.getSumTransaction();
        },
    },

    mounted() {
        this.getSumTransaction();
    },

    methods: {
        getSumTransaction() {
            this.loading = true;

            let options = {
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
                outlet_id: this.activeOutlet,
                filters: this.filters,
            };

            this.$http.get(this.api, { params: options }).then(response => {
                let data = response.data;
                this.types = this.types.map(obj => {
                    obj.total = data[obj.id];
                    return obj;
                });

                this.loading = false;
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/voided/es-report/summary.vue